import { reactive } from 'vue';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
  duration: number;
}

interface ToastStore {
  toasts: Toast[];
  show: (message: string, type?: ToastType, duration?: number) => void;
  remove: (id: number) => void;
}

// Toast service using reactive store
const toastStore: ToastStore = reactive({
  toasts: [] as Toast[],
  
  // Show a new toast notification
  show(message: string, type: ToastType = 'info', duration = 5000) {
    const id = Date.now();
    const toast: Toast = {
      id,
      message,
      type,
      duration
    };
    
    // Add toast to the list
    this.toasts.push(toast);
    
    // Auto-remove toast after duration
    if (duration > 0) {
      setTimeout(() => {
        this.remove(id);
      }, duration);
    }
    
    return id;
  },
  
  // Remove a toast by ID
  remove(id: number) {
    const index = this.toasts.findIndex(toast => toast.id === id);
    if (index !== -1) {
      this.toasts.splice(index, 1);
    }
  }
});

export default toastStore; 